import { IRegistrationResponseDataGraphQL } from "models/registration.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const registrationQueryConfig = {
  getRegistration: {
    query: queries.registration.getRegistration,
    queryKey: [QueryAPIKey.GetRegistration],
    errorMessageKey: "invitationNotFound",
    queryOptions: {
      select: (data: IRegistrationResponseDataGraphQL) => data.registration,
    },
  },
};
